import { BaseErrorLayout } from '@dvb/ui';
import { HeaderBar } from '@school-manage/ui/HeaderBar/HeaderBar';
import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export function EditProfileError() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <HeaderBar
        backBtnHandler={() => navigate({ to: '/profile' })}
        hasBackBtn
        title={t('changePassword')}
      />
      <BaseErrorLayout className="bg-background w-full" />
    </>
  );
}
